<template>
  <div>
    <div :class="{'left-panel':true, 'no-scroll':respond.show, 'centered':isCreate}">
      <div class="heading">
        <span class="cons-name" v-if="!isCreate">
          {{ corporateInfo.name }}
          <a class="stripe-link" :href="corporateInfo.stripeUrl" target="_blank" v-if="corporateInfo.stripeUrl">
            <i class="fa fa-link"></i>
          </a>
        </span>
        <span class="cons-name" v-else>CREATE PROFILE</span>
        <div class="switch" v-if="!isCreate">
          <span class="label" v-if="corporateInfo.active">ACTIVE</span>
          <span class="label" v-else>DEACTIVATED</span>
          <div :class="{'slider':true, 'active':corporateInfo.active, 'disabled':statusLoading}"
            @click="toggleStatus"></div>
        </div>
      </div>

      <div :class="['body', {'card':isCreate}]">
        <!-- <div class="cons-link">
          [<a :href="`#/consumer/${corporateInfo.consId}`" target="_blank">View Consumer Profile</a>]
        </div> -->

        <div :class="['collapsible', {'collapse':!contentShow.discountInfo}]">
          <div class="head" @click="contentShow.billingInfo = !contentShow.billingInfo">
            <i class="fa fa-minus-circle" v-show="contentShow.billingInfo"></i>
            <i class="fa fa-plus-circle" v-show="!contentShow.billingInfo"></i>
            <span>Discount Information</span>
          </div>

          <div class="content">
            <div class="medium-12 column">
              <div class="data-field">
                <div class="label">Discount Code</div>
                <!-- <input type="text" class="input" :disabled="loading" v-model="corporateInfo.discountCode" /> -->
                <select v-model="corporateInfo.discountCode" :disabled="discountList.loading || loading">
                  <option v-for="(dc, i) in discountList.list" :key="i" :value="dc.code">{{dc.name}}</option>
                </select>
                <span class="error-msg">{{ discountCodeValidation }}</span>
              </div>
            </div>
          </div>
        </div>

        <div :class="{'collapsible':true, 'collapse':!contentShow.accountInfo}">
          <div class="head" @click="contentShow.accountInfo = !contentShow.accountInfo">
            <i class="fa fa-minus-circle" v-show="contentShow.accountInfo"></i>
            <i class="fa fa-plus-circle" v-show="!contentShow.accountInfo"></i>
            <span>Account Information</span>
          </div>

          <div class="content">
            <div class="logo-box">
              <span class="recommended">Recommended size: 200 x 200 px</span>
              <div :class="{'img-hover-box':true, 'loading':upload.loading}">
                <img :src="corporateInfo.logo" v-if="corporateInfo.logo" />
                <i class="fas fa-user-circle" v-else></i>
                <div class="button cta small" @click="triggerUpload">CHANGE LOGO</div>
                <transition name="slide-up">
                  <i class="fa fa-spinner fa-spin fa-2x" v-show="upload.loading"></i>
                </transition>
              </div>
              <span class="error-msg">{{ upload.message }}</span>
              <input type="file" ref="uploadInput" v-show="false" @change="uploadFile" />
            </div>

            <div class="medium-12 column margin-B-m">
              <div class="data-field">
                <div class="label">Username</div>
                <input type="text" class="input" :disabled="loading"
                  v-model="corporateInfo.username" name="username" />
                <span class="error-msg">{{ validation.username }}</span>
              </div>
            </div>

            <div class="medium-12 column" v-if="isCreate">
              <div class="data-field">
                <div class="label">Password</div>
                <input type="password" class="input" :disabled="loading"
                  v-model="corporateInfo.password" />
                <span class="error-msg">{{ validation.password }}</span>
              </div>
            </div>
            <div class="medium-12 column margin-B-m" v-if="isCreate">
              <div class="data-field">
                <div class="label">Repeat Password</div>
                <input type="password" class="input" :disabled="loading"
                  v-model="repeatPassword" />
                <span class="error-msg">{{ validation.repeatPassword }}</span>
              </div>
            </div>

            <div class="medium-12 column margin-B-m">
              <div class="data-field">
                <div class="label">Corporate Name</div>
                <input type="text" class="input" :disabled="loading"
                  v-model="corporateInfo.name" />
                <span class="error-msg">{{ validation.name }}</span>
              </div>
            </div>

            <div class="medium-6 column margin-B-m">
              <div class="data-field">
                <div class="label">Email</div>
                <input type="text" class="input" :disabled="loading"
                  v-model="corporateInfo.email" />
                <span class="error-msg">{{ validation.email }}</span>
              </div>
            </div>
            <div class="medium-6 column margin-B-m">
              <div class="data-field">
                <div class="label">Corporate Color</div>
                <input type="text" class="input" :disabled="loading"
                  @click="showEmailColor = true" v-model="corporateInfo.color"/>
                <span class="error-msg">{{ validation.color }}</span>
                <div class="palette" :style="{'backgroundColor': '#' + corporateInfo.color}"
                  @click="showEmailColor = true"></div>
                <transition name="slide-down">
                  <div class="color-picker right" v-show="showEmailColor">
                    <chrome-picker v-model="emailColors" @input="updateColor"></chrome-picker>
                  </div>
                </transition>
              </div>
            </div>

            <div class="medium-12 column margin-B-m">
              <div class="data-field">
                <div class="label">Mobile</div>
                <div :class="{'input-group':true}">
                  <div class="country-select input-group-label" @click="selectCountry">
                    <span class="country-code">(+{{callingCode}}) </span>
                    <i class="fa fa-caret-down"></i>
                  </div>
                  <input type="text" class="input" :disabled="loading"
                    v-model="corporateInfo.mobile" />
                </div>
                <span class="error-msg">{{ validation.mobile }}</span>
              </div>
            </div>
            <div class="medium-12 column margin-B-m">
              <div class="data-field">
                <div class="label">Website</div>
                <input type="text" class="input" :disabled="loading"
                  v-model="corporateInfo.website" />
                <span class="error-msg">{{ validation.website }}</span>
              </div>
            </div>

            <div class="medium-12 column margin-B-m" v-if="!isCreate">
              <div class="button cta small" @click="password.show = true"
                v-show="!password.show">
                Change Password
              </div>
              <transition name="expand">
                <span class="success-password" v-show="password.success">Successfully changed password!</span>
              </transition>
              <transition name="expand">
                <div class="row password-box" v-show="password.show">
                  <div class="medium-12 column">
                    <div class="data-field">
                      <div class="label">Password</div>
                      <input type="password" class="input" :disabled="password.loading"
                        v-model="corporateInfo.password" />
                      <span class="error-msg">{{ validation.password }}</span>
                    </div>
                  </div>
                  <div class="medium-12 column margin-B-m">
                    <div class="data-field">
                      <div class="label">Repeat Password</div>
                      <input type="password" class="input" :disabled="password.loading"
                        v-model="repeatPassword" />
                      <span class="error-msg">{{ validation.repeatPassword }}</span>
                    </div>
                  </div>

                  <div class="medium-12 column margin-B-s has-error" v-if="password.message">{{ password.message }}</div>
                  <div class="medium-6 column margin-B-m">
                    <div :class="{'button cta xsmall block':true, 'disabled':password.loading}"
                      @click="password.show = false">Cancel</div>
                  </div>
                  <div class="medium-6 column margin-B-m">
                    <div :class="{'button cta xsmall success block':true, 'disabled':password.loading}"
                      @click="updatePassword">Save</div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>

        <div :class="{'collapsible':true, 'collapse':!contentShow.billingInfo}">
          <div class="head" @click="contentShow.billingInfo = !contentShow.billingInfo">
            <i class="fa fa-minus-circle" v-show="contentShow.billingInfo"></i>
            <i class="fa fa-plus-circle" v-show="!contentShow.billingInfo"></i>
            <span>Billing Information</span>
          </div>

          <div class="content">
            <div class="medium-12 column">
              <div class="data-field">
                <div class="label">Address1</div>
                <input type="text" class="input" :disabled="loading"
                  v-model="corporateInfo.billingAddress1" />
                <span class="error-msg">{{ validation.billingAddress1 }}</span>
              </div>
            </div>

            <div class="medium-12 column margin-B-s">
              <div class="data-field">
                <div class="label">Address2</div>
                <input type="text" class="input" :disabled="loading"
                  v-model="corporateInfo.billingAddress2" />
              </div>
            </div>

            <div class="medium-12 column margin-B-s">
              <div class="data-field">
                <div class="label">City</div>
                <input type="text" class="input" :disabled="loading"
                  v-model="corporateInfo.billingCity" />
                <span class="error-msg">{{ validation.billingCity }}</span>
              </div>
            </div>

            <div class="medium-6 columns margin-B-s">
              <div class="data-field">
                <div class="label">State</div>
                <select v-model="corporateInfo.billingState" :disabled="loading"
                  :class="{'has-error':false}">
                  <option value=""></option>
                  <option value="NonUS">Non US</option>
                  <option v-for="state in states" :value="state.label" :key="state.value">{{state.label}}</option>
                </select>
                <span class="error-msg">{{ validation.billingState }}</span>
              </div>
            </div>

            <div class="medium-6 column margin-B-s">
              <div class="data-field">
                <div class="label">Zip</div>
                <input type="text" class="input" :disabled="loading"
                  v-model="corporateInfo.billingZip" />
                <span class="error-msg">{{ validation.billingZip }}</span>
              </div>
            </div>

            <div class="medium-12 column margin-B-s" v-show="corporateInfo.billingState === 'NonUS'">
              <div class="data-field">
                <div class="label">Country</div>
                <select v-model="corporateInfo.biilingCountry" :disabled="loading"
                  :class="{'input':true, 'has-error':false}">
                  <option v-for="(country, index) in countries.all"
                    :key="index" :value="country.alpha2">{{country.name}}</option>
                </select>
                <span class="error-msg">{{ validation.biilingCountry }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fix-buttons">
        <div class="medium-12 column">
          <div class="button cta success block" @click="submit">
            <span v-if="loading">
              <i class="fa fa-spinner fa-spin"></i>
              Loading ...
            </span>
            <span v-else-if="_corporateId !== 'add'">UPDATE</span>
            <span v-else>CREATE ACCOUNT</span>
          </div>
        </div>
      </div>
    </div>

    <transition name="expand">
      <div class="respond-box" v-if="respond.show">
        <div class="vertical-center">
          <div class="card">
            <div class="success">
              <i class="fas fa-check-circle" v-if="respond.success"></i>
              <i class="fas fa-times-circle" v-else></i>
              <div class="label">{{ respond.label }}</div>
              <div class="message" v-if="!!respond.message" v-html="respond.message"></div>
            </div>
            <div class="button cta block small margin-T-l" @click="closeResponModal">Close</div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="expand">
      <div class="confirm-card" v-if="confirmCard.show">
        <div class="vertical-center">
          <div class="card">
            Are you sure you want to remove credit card?

            <div class="row">
              <div class="column small-6">
                <div :class="{'button cta block xsmall':true, 'disabled':confirmCard.loading}"
                  @click="confirmCard.show = false">No</div>
              </div>
              <div class="column small-6">
                <div :class="{'button cta block success xsmall':true, 'disabled':confirmCard.loading}"
                  @click="removeCard">Yes</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="toggle-mobile" @click="showRecords = !showRecords">
      <span v-if="!showRecords">Show Records <i class="fa fa-chevron-up"></i></span>
      <span v-else>Hide Records <i class="fa fa-chevron-down"></i></span>  
    </div>

    <div :class="['right-panel', showRecords ? 'mobile-right-panel' : '']" v-show="!isCreate">
      <ul class="tab">
        <li :class="{'active':activeTab === 0}" @click="activeTab = 0">Transactions</li>
        <li :class="{'active':activeTab === 1}" @click="activeTab = 1">Credit Card</li>
        <li :class="{'active':activeTab === 2}" @click="activeTab = 2">Invoice</li>
      </ul>

      <div class="tab-contents">
        <div :class="{'tab-content':true, 'active':activeTab == 0}">
          <transaction-filter :isMobile="isMobile"></transaction-filter>
          <transaction-list :isMobile="isMobile"></transaction-list>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab == 1}">
          <credit-card :isMobile="isMobile"></credit-card>
        </div>
        <div :class="{'tab-content':true, 'active':activeTab == 2}">
          <invoice-list :isMobile="isMobile"></invoice-list>
        </div>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <a :class="{'logs-toggle':true, on: showRightPanel}" v-show="showIconLog" @click="toggleRightPanel"><i :class="iconToggleRightPanel"></i></a>
    </transition>
    <div :class="{'toggle-panel': true, hide: showRightPanel}">
      <div class="heading">{{ $t('rsvpDetails.history') }}</div>
      <div class="tab-contents" @scroll="loadMoreLogs">
        <div class="logs">
          <corporate-logs :corporateId="$route.params.id"></corporate-logs>
        </div>
      </div>
      <transition name="slide-up">
        <div class="infinity-loader" v-show="loadingMoreLogs">
          <i class="fas fa-spinner fa-spin"></i> Loading
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
/* global CONFIG */
import TransactionFilter from './TransactionFilter.vue'
import TransactionList from './TransactionList.vue'
import CreditCard from './CreditCard.vue'
import InvoiceList from './InvoiceList.vue'
import CorporateLogs from './CorporateLogs.vue'
import { Chrome } from 'vue-color'
import US from 'us'
import ApiCorporateProfile from '@/modules/api/corporate/profile'
import ApiCorporateLogs from '@/modules/api/corporate/logs'

let phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()


export default {
  name: 'corporate-profile',
  components: { 'chrome-picker': Chrome, TransactionFilter, TransactionList, CreditCard, InvoiceList, CorporateLogs },
  data () {
    return {
      contentShow: {
        discountInfo: true,
        accountInfo: true,
        billingInfo: true
      },
      statusLoading: false,
      upload: {
        loading: false,
        message: ''
      },
      repeatPassword: '',
      showEmailColor: false,
      emailColors: '',
      colorDelay: '',
      countries: require('country-data').countries,
      validation: {
        logo: '',
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        cardOwner: '',
        creditCard: '',
        cardExpiration: '',
        cardCVV: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        biilingCountry: '',
      },
      respond: {
        show: false,
        success: false,
        label: '',
        message: '',
        id: ''
      },
      showBillingForm: false,
      confirmCard: {
        show: false,
        loading: false
      },
      cardId: '',
      cardType: '',
      password: {
        show: false,
        loading: false,
        message: '',
        success: false
      },
      activeTab: 0,
      isDisplayCountryCode: true,
      showRightPanel: true,
      showIconLog: true,
      loadingMoreLogs: false,
      showRecords: false,
      isMobile: false,
      discountCodeValidation: '',
      discountList: {
        loading: false,
        list: []
      }
    }
  },
  computed: {
    _corporateId () { return this.$route.params.id },
    corporateInfo () { return this.$store.state.corporate.profile.info },
    loading () { return this.$store.state.corporate.profile.loading },
    // loadingLogs () { return this.$store.state.corporate.logs.loading },
    states () {
      let states = []
      for (let key in US.states) {
        if (US.states.hasOwnProperty(key)) {
          states.push({
            value: key,
            label: US.states[key].name
          })
        }
      }
      return states
    },
    isCreate () { return this._corporateId === 'add' },
    callingCode () {
      if(this.isDisplayCountryCode) {
        this.displayMobileNumber()
      }
      return this.$store.state.countryCode.callingCode
    },
    iconToggleRightPanel () { return this.showRightPanel ? 'fa fa-clipboard-list fa-2x' : 'fas fa-times fa-2x'}
  },
  methods: {
    loadMoreLogs (event) {
      let scrollAndView = event.target.scrollTop + event.target.offsetHeight
      if (event.target.scrollHeight - scrollAndView < 1) {
        this.$store.commit('corporate/setCorporateLogsCurrentPage', this.$store.state.corporate.logs.currentPage + 1)
        this.getMoreCorporateLogs()
      }
    },
    toggleRightPanel () {
      let self = this
      self.showRightPanel = !self.showRightPanel
      if(!self.showRightPanel) {
        self.$store.commit('corporate/resetLogs')
        self.$store.commit('corporate/setCorporateLogsCurrentPage', 1)
        self.$store.commit('corporate/setLoadingLogs', true)
        self.refreshCorporateLogs()
      }
    },
    selectCountry() {
      this.$store.commit('countryCode/setCountryModal', true)
    },
    getMoreCorporateLogs () {
      let self = this
      self.loadingMoreLogs = true
      ApiCorporateLogs.getLogs(self, self._corporateId, function (res) {
        self.loadingMoreLogs = false
      })
    },
    refreshCorporateLogs () {
      let self = this
      ApiCorporateLogs.getLogs(self, self._corporateId, function (res) {
        self.$store.commit('corporate/setLoadingLogs', false)
      })
    },
    getCorporateData () {
      let self = this
      if (self._corporateId === 'add') {
        self.showBillingForm = true
        self.$store.commit('corporate/resetProfileInfo')
      } else {
        ApiCorporateProfile.getInfo(self, self._corporateId, res => {
          if (!res.error && res.list.length) {
            let info = res.list[0]
            self.$store.commit('corporate/setProfile', {
              id: info.id,
              consId: info.custContactID,
              logo: info.logoUrl,
              username: info.username,
              password: info.password,
              name: info.name,
              email: info.contactEmail,
              color: info.corporateColor,
              mobile: info.contactPhone,
              website: info.corporateWebsiteUrl,
              cardOwner: '',
              creditCard: '',
              cardExpiration: '',
              cardCVV: '',
              billingAddress1: info.billingAddress1,
              billingAddress2: info.billingAddress2,
              billingCity: info.billingCity,
              billingState: info.billingState,
              billingZip: info.billingZip,
              biilingCountry: info.billingCountry,
              stripeUrl: info.customer.customerURL,
              active: info.active === 1,
              discountCode: info.discountCode || ''
            })
            self.getCardInfo()
            self.getDiscountList()
          } else {
            self.$router.push('/accessdenied')
          }
        })
      }
    },
    triggerUpload () {
      if (this.loading) { return }
      this.$refs.uploadInput.click()
    },
    uploadFile (e) {
      if (!e.target.files.length) { return }

      let self = this
      let file = e.target.files[0]
      let fd = new FormData()
      fd.append('pic', file)

      self.upload.loading = true
      self.upload.message = ''

      self.$http.post(CONFIG.mediaHost + '/api/upload', fd, {
        header: {'Content-Type': 'multipart/form-data'}
      }).then(function (res) {
        self.upload.loading = false
        if (!res.body.success) {
          self.upload.message = 'Upload fail. Please try again.'
          // self.upload[self.upload.target].success = false
          return
        }

        self.corporateInfo.logo = res.body.data.url

      }, function (res) {
        self.upload.loading = false
        self.upload.message = res
        console.log('error', res)
      })
    },
    selectColor () {
      this.$store.commit('corporate/setProfileColor', this.emailColors.hex.substring(1, this.emailColors.hex.length))
      this.showEmailColor = false
    },
    updateColor (value) {
      let self = this
      if (self.colorDelay) {
        clearTimeout(self.colorDelay)
      }

      self.$store.state.corporate.profile.info.color = value.hex.substring(1, value.hex.length)
      self.colorDelay = setTimeout(function () {
        self.showEmailColor = false
      }, 1200)
    },
    isNumber (evt) {
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
        return
      }
      return true;
    },
    formatExpCC () {
      let cardExp = this.corporateInfo.cardExpiration
      if (cardExp.length === 2 && !isNaN(cardExp)) {
        this.corporateInfo.cardExpiration = cardExp + '/'
      }
    },
    submit () {
      let self = this
      if (self.loading || !self.validate() || self.upload.loading) { return }

      self.$store.commit('corporate/setProfileLoading', true)

      if (self.isCreate) {
        ApiCorporateProfile.create(self, res => {
          self.$store.commit('corporate/setProfileLoading', false)
          if (!res.error) {
            self.respond = {
              show: true,
              success: true,
              label: 'Successfully updated profile.',
              message: ''
            }
            window.location = '/#/corporate/' + res.id
          } else {
            self.respond = {
              show: true,
              success: false,
              label: 'respond-box',
              message: res.error.message,
              id: ''
            }
          }
        })
      } else {
        ApiCorporateProfile.update(self, res => {
          self.$store.commit('corporate/setProfileLoading', false)
          if (!res.error) {
            self.respond = {
              show: true,
              success: true,
              label: 'Successfully updated profile.',
              message: ''
            }
          } else {
            self.respond = {
              show: true,
              success: false,
              label: 'Oops! Something went wrong.',
              message: res.error.message,
              id: ''
            }
          }
        })
      }
      self.$store.commit('corporate/resetLogs')
      self.$store.commit('corporate/setCorporateLogsCurrentPage', 1)
      self.$store.commit('corporate/setLoadingLogs', true)
      setTimeout(function () {
        self.refreshCorporateLogs()
      }, 2000)
    },
    validate () {
      let noError = true

      if (this.upload.message !== '') {
        noError = false
      }

      this.discountCodeValidation = ''
      for (let field in this.validation) {
        if (!this.isCreate && field === 'password') { continue }
        this.validation[field] = ''
        if (this.corporateInfo[field] === '') {
          this.validation[field] = 'This field cannot be empty.'
          noError = false
        }
      }

      if (this.corporateInfo.username.indexOf(' ') > -1) {
        this.validation.username = 'Space is not allowed'
        noError = false
      }

      if (this.isCreate) {
        if (this.repeatPassword === '') {
          this.validation.repeatPassword = 'This field cannot be empty.'
          noError = false
        }

        if (this.repeatPassword !== '' && this.corporateInfo.password !== '' &&
          this.repeatPassword !== this.corporateInfo.password
        ) {
          this.validation.repeatPassword = 'Password and Repeat password doesn\'t match.'
          noError = false
        }
      }

      return noError
    },
    clearValidation () {
      this.validation = {
        logo: '',
        username: '',
        password: '',
        repeatPassword: '',
        name: '',
        email: '',
        color: '',
        mobile: '',
        website: '',
        billingAddress1: '',
        billingCity: '',
        billingState: '',
        biilingCountry: ''
      }
    },
    closeResponModal () {
      this.respond.show = false
      if (this.respond.id) {
        window.location = '/#/corporate/' + this.respond.id
      }
    },
    toggleStatus () {
      let self = this
      if (self.statusLoading) { return }

      self.statusLoading = true
      ApiCorporateProfile.toggleStatus(self, {
        id: self.corporateInfo.id,
        active: self.corporateInfo.active
      }, res => {
        self.statusLoading = false

        if (res.error) {
          self.respond = {
            show: true,
            success: false,
            label: 'Oops! Something went wrong.',
            message: res.error.message
          }
          return
        }

        // self.disableConsumerAccnt()
        self.corporateInfo.active = !self.corporateInfo.active
        self.$store.commit('corporate/resetLogs')
        self.$store.commit('corporate/setCorporateLogsCurrentPage', 1)
        self.$store.commit('corporate/setLoadingLogs', true)
        setTimeout(function () {
          self.refreshCorporateLogs()
        }, 2000)
      })
    },
    disableConsumerAccnt () {
      let self = this
      let action = !self.corporateInfo.active ? 'post' : 'delete'
      self.$sdk[action](`/provider/${self.corporateInfo.consId}/active`, {
        token: self.$store.state.session.sessionToken
      }, res => {
        self.corporateInfo.active = !self.corporateInfo.active
        self.$store.commit('corporate/resetLogs')
        self.$store.commit('corporate/setCorporateLogsCurrentPage', 1)
        self.$store.commit('corporate/setLoadingLogs', true)
        setTimeout(function () {
          self.refreshCorporateLogs()
        }, 2000)
      })
    },
    addCard (id) {
      let self = this
      this.$sdk.post('/consumer/' + id + '/cards', {
        token: self.$store.state.session.sessionToken,
        title: '',
        name: self.corporateInfo.cardOwner,
        number: self.corporateInfo.creditCard,
        expiration: self.corporateInfo.cardExpiration,
        cvv: self.corporateInfo.cardCVV,
        billingAddress: self.corporateInfo.billingAddress1 + ' ' + self.corporateInfo.billingAddress1,
        billingCity: self.corporateInfo.billingCity,
        billingState: self.corporateInfo.billingState,
        billingCountry: self.corporateInfo.biilingCountry,
        billingZip: self.corporateInfo.billingZip,
      }, res => {
          self.respond = {
            show: true,
            success: true,
            label: 'Successfully updated profile.',
            message: '',
            id: ''
          }

          self.cardType = self.cardIcon(res.card.title)
          self.$store.commit('corporate/setProfileCreditInfo', {
            cardOwner: self.corporateInfo.cardOwner,
            creditCard: res.card.cardNumber,
            cardExpiration: res.card.cardExpires
          })
          self.showBillingForm = false
      })
    },
    getCardInfo () {
      let self = this
      self.$sdk.get('/consumer/' + self.corporateInfo.consId + '/cards', {
        token: self.$store.state.session.sessionToken,
      }, res => {
        if (res.list.length) {
          self.cardType = self.cardIcon(res.list[0].cardType)
          self.cardId = res.list[0].id
          self.$store.commit('corporate/setProfileCreditInfo', {
            cardOwner: res.list[0].cardholderName,
            creditCard: res.list[0].cardNumber,
            cardExpiration: res.list[0].cardExpires
          })
        }
      })
    },
    cardIcon (val) {
      switch (val) {
        case 'Visa': return 'visa'
        case 'Master Card': return 'mastercard'
        case 'MasterCard': return 'mastercard'
        case 'mastercard': return 'mastercard'
        case 'American Express': return 'amex'
        case 'Discover': return 'discover'
        case 'JCB': return 'jcb'
        case 'Diners Club': return 'diners'
        default: return 'unknown'
      }
    },
    removeCard () {
      let self = this
      if (self.confirmCard.loading) { return }

      self.confirmCard.loading = true
      self.$sdk.delete('/consumer/' + self.corporateInfo.consId + '/cards/' + self.cardId, {
        token: self.$store.state.session.sessionToken,
      }, res => {
        self.confirmCard.loading = false
        self.confirmCard.show = false

        if (!res.error) {
          self.cardId = ''
          self.$store.commit('corporate/setProfileCreditInfo', {
            cardOwner: '',
            creditCard: '',
            cardExpiration: ''
          })

        } else {
          self.respond = {
            show: true,
            success: false,
            label: 'Oops! Something went wrong.',
            message: res.error.message,
            id: ''
          }
        }
      })
    },
    updatePassword () {
      let self = this
      if (self.password.loading) { return }

      let hasError = false
      if (self.corporateInfo.password === '') {
        self.validation.password = 'This field cannot be empty.'
        hasError = true
      }
      if (this.repeatPassword === '') {
        this.validation.repeatPassword = 'This field cannot be empty.'
        hasError = true
      }
      if (this.repeatPassword !== '' && this.corporateInfo.password !== '' &&
        this.repeatPassword !== this.corporateInfo.password
      ) {
        this.validation.repeatPassword = 'Password and Repeat password doesn\'t match.'
        hasError = true
      }
      if (hasError) { return }

      self.password.loading = true
      self.password.message = ''
      self.$sdk.post('/admin/corporateprofile/' + self._corporateId + '/password', {
        token: self.$store.state.session.sessionToken,
        password: self.corporateInfo.password
      }, res => {
        self.password.loading = false
        if (res.error) {
          self.password.message = res.error.message
        }

        self.password.show = false
        self.password.success = true
        setTimeout(() => {
          self.password.success = false
        }, 3000)
      })
      self.$store.commit('corporate/resetLogs')
      self.$store.commit('corporate/setCorporateLogsCurrentPage', 1)
      self.$store.commit('corporate/setLoadingLogs', true)
      setTimeout(function () {
        self.refreshCorporateLogs()
      }, 2000)
    },
    displayMobileNumber () {
      let self = this
      let mobile = self.corporateInfo.mobile
      if (mobile) {
        if(mobile.slice(0,1) !== '+') {
          mobile = '+' + self.corporateInfo.mobile
        }
        try {
          let mobileNumber = phoneUtil.parse(mobile, "")
          let countryCode = mobileNumber.getCountryCode()
          let nationalNumber = mobileNumber.getNationalNumber()
          self.$store.commit('countryCode/setCallingCode', countryCode)
          self.$store.commit('corporate/setNationalNumber', nationalNumber)
          self.isDisplayCountryCode = false
        } catch(err) {
          self.$store.commit('countryCode/setCallingCode', '???')
          self.$store.commit('corporate/setNationalNumber', self.corporateInfo.mobile)
        }
      }
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    },
    getDiscountList () {
      let self = this
      if (self.discountList.loading || self.discountList.list.length) return
      self.discountList.loading = true
      
      self.$sdk.get('/discountcode', {
        token: self.$store.state.session.sessionToken,
        order: 'id',
        orderAsc: '',
        search: '',
        pageSize: 999
      }, res => {
        self.discountList.loading = false
        if (!res.error) {
          res.list.forEach(dc => {
            let amount = dc.type === '$' ? `${dc.type}${dc.amount}` : `${dc.amount}${dc.type}`
            self.discountList.list.push({
              code: dc.code,
              name: `${dc.code} - ${amount}`
            })
          })
        }
      })
    }
  },
  watch: {
    _corporateId (val) {
      this.clearValidation()
      if (val === 'add') {
        this.repeatPassword = ''
        this.$store.commit('corporate/resetProfileInfo')
      } else {
        this.getCorporateData()
      }
    },
    'corporateInfo.billingState': function (val) {
      if (val && val !== 'NonUS') {
        this.corporateInfo.biilingCountry = 'US'
      }
    },
    isCreate (val) {
      if (val) {
        this.showBillingForm = true
      }
    }
  },
  mounted () {
    this.clearValidation()
    this.getCorporateData()
    this.setScreenSize()
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/scss/_creditCardIcons';

.collapsible{
  margin-bottom: 5px;

  .head{
    color: #0D79F2;
    margin-bottom: 2px;
    cursor: pointer;
    text-transform: uppercase;

    i{ margin-right: 5px; }
    span { font-weight: 600; }
  }
  .content{
    margin-left: 6px;
    padding: 5px 0 5px 15px;
    border-left: 2px solid #ddd;
    max-height: 800px; /* define precise max-height for more smoother transition */
    height: auto;
    overflow: hidden;
    transition:all 0.35s ease-out;

    .field-row{ margin-bottom: 15px; }
    .field-row:last-child{ margin-bottom: 0; }
  }
  &.collapse .content{
    max-height: 0;
    padding: 0 15px;
  }
}

.toggle-mobile {
  display: none;
}

.left-panel{
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  width: 500px;
  height: 100%;
  box-shadow: 2px 0 4px rgba(0,0,0,0.2);
  background-color: #F4F8F9;
  overflow-y: auto;

  &.no-scroll{ overflow: hidden; }
  .heading{ padding-left: 50px; }
  &.centered{
    width: 100%;

    .heading{
      background:#fff;
      border-bottom: 1px solid #ddd;
      margin-bottom: 20px;
    }
  }
}

.right-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: calc(100% - 500px);
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #d5d5d5;
  overflow-y: hidden;

  .heading{
    font-size:24px;
    padding: 10px 20px;
  }

  .tab{
    background: #d5d5d5;
    & .active{ background: #ededed; }
  }
  .tab-contents{ background: #ededed; }
}

.heading{
  height: 50px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 10px 0;

  & .cons-name{
    padding: 0 5px 0 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
    display: inline-block;
  }
}

.switch{
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  float: right;

  .slider{
    position: relative;
    display: inline-block;
    width: 50px;
    height: 26px;
    border-radius: 20px;
    background: #ccc;
    position: relative;
    cursor: pointer;
    transition:all .25s ease-in-out;

    &.disabled{ opacity: .4; }
    &:before{
      content: '';
      position: absolute;
      top: 2px;
      left: 3px;
      width: 21px;
      height: 21px;
      border-radius: 50%;
      background: #fff;
      transition:all .25s ease-in-out;
      box-shadow: 1px 1px 2px rgba(0,0,0, .25);
    }
    &.active{
      background: #57d1b7;
      &:before{ left: 25px; }
    }
  }
  .label{
    display: inline-block;
    vertical-align: 8px;
    margin-right: 5px;
    font-size: 14px;
    color: #555;
    text-transform: uppercase;
  }
}

.body{
  padding: 20px;
  background: #fafafa;
  border-top: 1px solid #ccc;
  height: calc(100vh - 111px);
  overflow-y: auto;

  &.card{
    width: 500px;
    margin: 0 auto;
  }
}

.cons-link{
  margin-bottom: 20px;
  font-size: 14px;

  a{
    letter-spacing: .5px;
    display: inline-block;
    margin: 0 5px;
    font-weight: 600;
  }
}

.logo-box{
  text-align: center;
  padding: 0 20px 20px;

  .fa-user-circle{
    font-size: 140px;
    margin-top: 30px;
    color: #f2ad6d;
  }
  img{
    max-width: 200px;
    max-height: 200px;
    cursor: pointer;
    transition: .2s ease all;
  }
  .img-hover-box{
    position: relative;
    display: inline-block;
    border: 3px dashed #ddd;
    width: 206px;
    height: 206px;
    overflow: hidden;
    background: #fff;

    .button{
      position: absolute;
      top: 60%;
      left: 50%;
      margin-top: -20px;
      margin-left: -63px;
      opacity: 0;
    }
    &:hover{
      img{ opacity: .6; }
      .button{
        opacity: 1;
        top: 50%;
      }
    }
    .fa-spinner{
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 3;
      margin-top:-16px;
      margin-left:-16px;
    }
    &.loading{
      img{ opacity: .6; }
      &:hover .button{ display: none; }
    }
  }
  .recommended{
    display: block;
    font-size: 14px;
    margin-bottom: 5px;
    color: #666;
    font-weight: 600;
  }
  .error-msg{
    display: block;
    font-weight: 100;
    margin-top: 2px;
    color: #f20d0d;
    font-size: 12px;
    font-style: italic;
  }
}

.details-box{ padding: 20px 0; }

.data-field{
  padding: 5px;
  position: relative;

  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;

    &.has-error{ color: #f20d0d; }
  }
  .input{
    margin: 1px 0 0;
    padding: 5px;
    font-size: 14px;
    color: #333;
    line-height: inherit;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background: #eee; }
  }
  .error-msg{
    font-size: 11px;
    line-height: 1.6;
    color: #f20d0d;
    font-style: italic;
    display: block;
  }
  select{
    border: 1px solid #ddd;
    padding: 5px;
    color: #333;
    height: 35px;
    position: relative;
    font-size:14px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url('/assets/img/dropdown-arrow.png');
    background-repeat: no-repeat;
    background-position: right 50%;
    transition: all .35s ease;

    &.has-error{ border-color: #f20d0d; }
    &:disabled{ background-color: #eee; }
  }
}

.billing-box{
  padding: 15px;
  background: #ebf4ff;
  border: 1px solid #0d79f2;
  border-radius: 8px;
  margin: 10px 0;

  .billing-label{
    font-size: 21px;
    font-weight: 600;
    padding-bottom: 5px;
    color: #333;
    text-align: center;
  }
  .label{ color: #122a43; }
  .error-msg{ color: #fff; }
}

.palette{
  position: absolute;
  top: 27px;
  right: 13px;
  background-color: #fafafa;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  cursor: pointer;
}

.color-picker{
  position: absolute;
  top: 100%;
  z-index: 3;
  transform-origin: top center;

  &.right{ right: 0; }
  &.left{ left: 0; }
}

.success-password{
  font-size: 13px;
  font-weight: 600;
  color: #11b35d;
  padding-left: 5px;
}

.password-box{
  border: 1px solid #888;
  background: #fff;
  padding: 10px;
  border-radius: 2px;

  .medium-6{
    &:first-child{ padding-right: 5px; }
    &:last-child{ padding-left: 5px; }
  }
  .has-error{
    font-size: 11px;
    color: #f20d0d;
    border: 1px solid #f20d0d;
    background: #fff1f1;
    padding: 4px;
  }
}

.fix-buttons{
  position: fixed;
  z-index: 2;
  bottom: 0;
  left: 0;
  padding: 10px;
  width: 500px;
  height: 60px;
  background: #eee;
  box-sizing: border-box;
  display: flex;

  a{
    width: 50%;
    display: inline-block;
    margin: 0 10px 0 auto;

    &.right{ margin-left: auto; }
  }
}

.card-list-box{
  padding: 0 5px;
  margin: 20px 0 10px;

  .label{
    color: #888;
    font-weight: 600;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 130%;
  }
  .card-box{
    background: #fff;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 2px;

    .logo, .info, .action{ display: inline-block; }
    .logo{
      width: 40px;
      text-align: center;

      .far{
        font-size: 21px;
        position: relative;
        top: 2px;
      }
      .cc-icon{
        position: relative;
        top: 5px;
      }
    }
    .info{
      width: calc(100% - 130px);
      font-size: 13px;

      .number{
        font-weight: 600;
        color: #333;
      }
      .exp{
        display: inline-block;
        margin-left: 5px;
        color: #aaa;
      }
    }
    .action{
      font-size: 14px;
      width: 80px;
      text-align: center;
      vertical-align: 5px;
    }
  }
}

.respond-box, .confirm-card{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  background: rgba(0,0,0, .5);
  display: table;

  .vertical-center{
    display: table-cell;
    vertical-align: middle;
  }
  .card{
    width: 80%;
    max-width: 500px;
    margin: 0 auto;
    padding: 15px;
    text-align: center;
  }
  .fa-check-circle, .fa-times-circle{
    font-size: 100px;
    color: #26d97a;
    margin-bottom: 5px;
  }
  .fa-times-circle{ color: #F20D0D; }
  .label{
    font-weight: 600;
    color: #505050;
  }
  .message{
    font-size: 14px;
    color: #777;
    margin: 10px 0;
  }
}

.confirm-card{
  .small-6{
    margin-top: 25px;
    padding: 0 10px;
  }
}

.tab{
  list-style: none;
  padding: 0;
  margin: 15px 0 0;
  display: flex;
  position: relative;
  z-index: 2;

  li{
    color: #0D79F2;
    padding: 15px 25px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    display: inline-block;
    text-transform: uppercase;
    cursor: pointer;

    &.grow{
      flex-grow: 100;
    }
    &.active{
      background: #fff;
      box-shadow: 0 -1px 2px rgba(0,0,0, .1);
      border-radius: 2px 2px 0 0;
      color: #777;
    }
  }
}

.tab-contents{
  background: #fff;
  z-index: 2;
  position: relative;
  box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.1);

  .tab-content{
    padding: 20px;
    display: none;

    &.no-H-padding{ padding: 20px 0; }
    &.active{
      display: block;
    }
  }
}

.input-group {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  position: relative;
  margin-bottom: 0;

 .input-group-label {
  padding: 0 10px;
  border: 1px solid #cacaca;
  background: #f4f8f9;
  color: #0a0a0a;
  text-align: center;
  white-space: nowrap;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
  -webkit-flex: 0 0 auto;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
 }

 .mobile-input {
  padding-left: 25px;
  border-radius: 1px;
  border-left: 0;
 }

  &.small {
    .mobile-input {
      padding-left: 35px;
    }
  }
  &.medium {
    .mobile-input {
      padding-left: 45px;
    }
  }
  &.large {
    .mobile-input {
      padding-left: 55px;
    }
  }
  &.xl {
    .mobile-input {
      padding-left: 65px;
    }
  }

}

$toggle-size: 50px;
$toggle-panel-width: 400px;

.toggle-panel {
  transition: all .6s ease;

  .tab-contents{
    background: #ededed;
    .logs {
      padding: 20px;
    }
  }
}

.logs-toggle {
  position: fixed;
  right: 0;
  top: 0;
  z-index: 3;
  width: $toggle-size;
  height: $toggle-size;
  line-height: $toggle-size;
  text-align: center;
  color: #777;
  transition: all 250ms;
  border-radius: 0;
  background-color: #F25E0D;
  color: #fff;
  border-bottom-left-radius: 3px;
  box-shadow: -2px 0 8px rgba(0,0,0,0.35);
  cursor: pointer;
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
  -webkit-transition: .5s ease;
  -moz-transition: .5s ease;
  -o-transition: .5s ease;
  transition: .5s ease;

  & i {
  line-height: inherit;
  }

  &.on{
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease;
  -moz-transition: .5s ease;
  -o-transition: .5s ease;
  transition: .5s ease;
  }
}

.toggle-panel{
  position: fixed;
  z-index: 2;
  right: 0;
  top: 0;
  width: $toggle-panel-width;
  height: 100%;
  box-shadow: -2px 0 4px rgba(0,0,0,0.2);
  background-color: #f4f8f9;
  // overflow-y: auto;

  &.hide{
    right: -#{$toggle-panel-width};
    box-shadow: -2px 0 8px rgba(0,0,0,0.0);
  }

  .heading{
    font-size:24px;
    padding: 10px 20px;
    margin-bottom: 7px;
  }

  .tab{
    background: #d5d5d5;
    & .active{ background: #ededed; }
    li{ width: 50%; }
  }
  .tab-contents{
    background: #fff;
    display: block;
    height: calc(100% - 57px);
    overflow-y: auto;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

.country-select {
  margin-top: 1px;
  cursor: pointer;
  color: #333;
  transition: 0.3s;
}

.country-select:hover {
  background-color: #e6e6e6;
}

.country-code {
  margin-right: 3px;
  font-weight: 100;
  font-size: 15px;
}

.infinity-loader{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(0,0,0, .6);
  color: #fff;
  transform-origin: bottom center;
  text-align: center;
  font-size: 18px;
  line-height: 40px;
  z-index: 100;
}

.margin-B-s{ margin-bottom: 5px; }
.margin-B-m{ margin-bottom: 10px; }
.margin-T-l{ margin-top: 15px; }

.slide-up-enter-active, .slide-up-leave-active { transition: all .6s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: translateY(30px);
  opacity: 0;
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

.expand-enter-active, .expand-leave-active { transition: all .1s ease; }
.expand-enter, .expand-leave-to {
  transform: scale(.95);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .collapsible {
    .content {
      max-height: 920px;
    }
  }

  .password-box {
    .medium-6 {
      width: 50%;
      padding: 0;
    }
  }
  .left-panel {
    width: 100%;
    padding-bottom: 100px;
    .heading {
      display: flex;
      justify-content: space-between;
      .cons-name {
        padding: 0 15px 0 15px;
        width: 140px;
      }
      .switch {
        display: block;
        padding-top: 5px;
        padding-left: 10px;
        padding-right: 50px;
        padding-top: 1px;
      }

      .prov-options {
        position: absolute;
        right: 0;
        top: 15px;
      }
    }

    .tab {
      margin: 35px 0 0;
      display: flex;
      overflow-x: scroll;

      li {
        width: auto;
      }
    }
  }

  .toggle-mobile {
    display: block;
    color: #fff;
    background-color: #333;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    padding: 8px 0;
    height: 45px;
    -webkit-transition: top .25s;
    transition: top .25s;
    z-index: 9;
    text-transform: uppercase;
    font-weight: 900;
  }

  .right-panel {
    z-index: 1;
    width: 100%;
    top: 100%;
    transition: all 0.3s ease;

    &.mobile-right-panel {
      top: 0;
      z-index: 2;

      .tab {
        margin-top: 70px;
        display: flex;
        overflow-x: scroll;

        li {
          font-size: 13px;
        }
      }

      .tab-contents {
        width: 100%;
        height: calc(100vh - 142px);
        overflow-y: scroll;
        .tab-content {
          padding-bottom: 60px;

          &.history-panel {
            padding: 0;
            padding-top: 20px;
            padding-bottom: 60px;
          }

        }
        .fixed-footer {
          width: 100%;
          bottom: 45px;
          background: #fff;
          color: #000;
          border-top: 1px solid #aaa;
        }
      }

      .logs-panel {
        width: 100%;
      }
    }
  }

  .fix-buttons {
    width: 100%;
    bottom: 45px;
    a {
      margin: 0 auto;
    }
  }

  .toggle-panel .heading {
    display: flex;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Corporate/CorporateProfile.vue